import { useEffect, useState } from 'react'
import { getReceptionistCalendarStatus, type ReceptionistCalendarStatus } from './lib/communications'
import { useCrmIdentity } from './lib/crmIdentity'

export function ReceptionistCalendarStatus() {
  const { workspaceId, userId } = useCrmIdentity()
  const [result, setResult] = useState<{scope:string;status:ReceptionistCalendarStatus|null}>({ scope: '', status: null })
  const scope = `${workspaceId}:${userId}`
  useEffect(() => {
    let active = true
    const refresh = () => { void getReceptionistCalendarStatus().then(status => { if (active) setResult({scope,status}) }).catch(() => { if (active) setResult({scope,status:null}) }) }
    refresh()
    window.addEventListener('focus', refresh)
    return () => { active = false; window.removeEventListener('focus', refresh) }
  }, [scope])
  const status = result.scope === scope ? result.status : null
  const bindings = status?.bindings.filter(item => item.bindingRole === 'MAIN' && item.active && item.readVerified && item.writeVerified) || []
  const observed = bindings.flatMap(item => item.coverage.filter(coverage => coverage.complete && coverage.fresh))
  return <div className="calendar-sync-note" role="status">
    Team booking calendar <b>{!status ? 'Evidence unavailable' : !status.enabled ? 'Not configured' : !bindings.length ? 'Binding or permission verification pending' : !observed.length ? 'Sync pending or stale' : 'Complete coverage observed'}</b>.
    {observed.length > 0 && <> Last complete sync: {new Date(observed.map(item => item.observedAt).sort().at(-1)!).toLocaleString()}. Timezone: {bindings.map(item => item.timezone || 'Unverified').join(', ')}. Booking confirmation requires a provider readback.</>}
  </div>
}
